
export function getLocaleFromUrl() {
    const parts = window.location.pathname.split('/');
    if (parts.length > 1) {
        const segment = parts[1];
        // Check if segment matches 'es', 'en', 'es-cl', 'es-mx', etc.
        // 2 chars or 5 chars with hyphen
        if (segment.match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
            // Filter out common 2-letter non-locales if any, but usually locale is first.
            // Assuming it is a locale.
            return segment;
        }
    }

    // Fallback if URL doesn't have locale
    if (typeof window.I18n !== 'undefined' && window.I18n.locale) {
        return window.I18n.locale;
    }
    return (document.documentElement.lang || "es").toLowerCase();
}

export function buildLocalePath(path) {
    const locale = getLocaleFromUrl();
    const cleanPath = path.startsWith('/') ? path : '/' + path;
    if (locale) {
        return `/${locale}${cleanPath}`;
    }
    return cleanPath;
}
